<script lang="ts">
    import Fa from 'svelte-fa'
    import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    export let item: Partial<QuotationPayment> = undefined
    import { createEventDispatcher, onMount } from 'svelte'
    import { QuotationPayment } from '../../../modules/posApi/quotation/quotation.entity'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }

    let methods = ['Dinheiro', 'Pix', 'Crédito', 'Débito', 'Boleto', 'Cheque', 'Crediário', 'Financeira', 'Outros*']
    const methodOptions = methods.map((m) => ({ value: m, label: m }))
    const installmentOptions = Array.from({ length: 24 }, (_, i) => ({ value: i + 1, label: String(i + 1) }))

    function getPrep(method: string) {
        if (method === 'Dinheiro') return 'em'
        if (method === 'Pix') return 'por'
        if (method === 'Financeira') return 'via'
        if (method === 'Outros*') return 'via'
        return 'no'
    }

    // abre um item já existente direto em edição (a folha do mobile desenha a linha fechada por conta
    // própria e só usa este componente para editar). No desktop fica desligado.
    export let startEditing: boolean = false

    let step = 1
    let isNew = false
    async function editEntity() {
        step = 2
    }

    async function newEntity() {
        isNew = true
        step = 2
        item = new QuotationPayment()
    }

    async function cancelEntity() {
        dispatch('cancel')
        item = undefined
        step = 1
    }

    async function confirmEntity() {
        if (!item.installmentFrom || !item.installmentValue || !item.installmentTo || !item.installmentMethod) {
            window.error('Informe todas as opções antes de confirmar.')
            return
        }
        console.log('item', item)
        dispatch('added', item)
        if (isNew) item = undefined
        step = 1
        isNew = false
    }

    onMount(() => {
        if (!item) newEntity()
        else if (startEditing) step = 2
    })

    function friendlyInstallment() {
        if (item.installmentFrom === item.installmentTo) {
            if (item.installmentFrom === 1) {
                return 'em 1 vez'
            } else {
                return 'em ' + item.installmentFrom + ' vezes'
            }
        }
        if (item.installmentFrom === 1) {
            return 'em até ' + item.installmentTo + ' vezes'
        }
        return 'de ' + item.installmentFrom + ' a ' + item.installmentTo + ' vezes'
    }
</script>

{#if item !== undefined}
    <div class={className}>
        {#if step === 1}
            <div class="row line">
                <div class="col-md-3">
                    {#if item.dpValue}
                        {window.api.utils.utils.toReal(item.dpValue)}
                        {getPrep(item.dpMethod)}
                        {item.dpMethod.toLowerCase()}
                    {:else}
                        sem entrada
                    {/if}
                </div>
                <div class="col-md-5">
                    {window.api.utils.utils.toReal(item.installmentValue)}
                    {getPrep(item.installmentMethod)}
                    {item.installmentMethod.toLowerCase()}
                    {friendlyInstallment()}
                </div>
                <div class="col-md-2 text-end">
                    {window.api.utils.utils.toReal(item.installmentValue + item.dpValue)}
                </div>
                <div class="col-md-2 text-end">
                    <button
                        class="btn btn-secondary btn-sm"
                        on:click={() => {
                            editEntity()
                        }}><Fa icon={faEdit} /> Editar</button
                    >
                </div>
            </div>
            <!-- <div class="row line h-full content">
                <div class="col">
                    <div class="label">Meio de pgto</div>
                    <div class="item">{item.paymentMethod.label}</div>
                </div>
                <div class="col-3">
                    <div class="label">Parcelas</div>
                    <div class="item">{item.installments}</div>
                </div>
                <div class="col-3">
                    <div class="label">Valor</div>
                    <div class="item">{item.value}</div>
                </div>

                <div class="col-md text-center">
                    <button
                        class="btn btn-secondary btn-sm mt-3 mb-2"
                        on:click={() => {
                            editEntity()
                        }}><Fa icon={faEdit} /> Editar</button
                    >
                </div>
            </div> -->
        {/if}
        {#if step === 2}
            <!-- tudo numa linha só, como no editor de itens: os dois campos de parcela guardam um
                 número de uma ou duas casas, então cabem estreitos e sobra largura para o resto -->
            <ZContainer gapRow="8px" gapCol="8px">
                <!-- entrada e restante são dois pagamentos distintos: cada um tem meio e valor -->
                <Zinput size={2} sizeM={6} label="Entrada em" type="select" options={methodOptions} bind:value={item.dpMethod} />
                <Zinput size={2} sizeM={6} label="Valor da entrada" type="number" bind:value={item.dpValue} />
                <Zinput size={2} sizeM={6} label="Restante em" type="select" options={methodOptions} bind:value={item.installmentMethod} />
                <Zinput size={2} sizeM={6} label="Valor do restante" type="number" bind:value={item.installmentValue} />
                <!-- a opção vale para uma faixa de parcelas ("de 1 a 6 vezes"), não para um número só -->
                <!-- rótulo curto: na coluna estreita "Parcelas de" não cabe e passa por cima da seta -->
                <Zinput size={1} sizeM={6} label="Parcelas" type="select" options={installmentOptions} bind:value={item.installmentFrom} />
                <Zinput size={1} sizeM={6} label="até" type="select" options={installmentOptions} bind:value={item.installmentTo} />
                <!-- os botões fecham a linha, só com ícone (o title dá o nome no hover) -->
                <ZContainerCol size={2} sizeM={12} flex={true} horizontalAlign="end">
                    <Zbutton grow={true} class="me-2" color="red" icon={faTrashAlt} title="Excluir" on:click={cancelEntity} />
                    <Zbutton grow={true} color="green" icon={faCheck} title="Confirmar" on:click={confirmEntity} />
                </ZContainerCol>
            </ZContainer>
        {/if}
    </div>
{/if}

<style>
    /* o editor agora é ZContainer + Zinput: as larguras fixas e os ajustes de coluna do Bootstrap
       saíram junto com o markup que os usava */
</style>
